import {theme} from 'config/themes';
import {StyleSheet, View} from 'react-native';

export interface DropFrameProps {
  stroke?: 'small' | 'medium' | 'large';
  color?: string;
}

export function DropFrame(props: DropFrameProps) {
  return (
    <View
      pointerEvents="none"
      style={[
        styles.outline,
        props.stroke && styles[props.stroke],
        {borderColor: props.color || theme.app.logo},
      ]}
    />
  );
}

const styles = StyleSheet.create({
  outline: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    borderColor: theme.app.logo,
    borderRadius: 6,
    borderWidth: 5,
  },
  large: {
    borderWidth: 5,
  },
  medium: {
    borderWidth: 2,
  },
  small: {
    borderWidth: 1,
  },
});
